import { updateLegend } from './controls/legend'
import { g, initD3, resizeMap } from './map/d3Renderer'
import { enableEditButtons } from './map/drawing'
import { updateProjAndExtent } from './functions'
import { updateWMTSes } from './map/layers'
import { initMeasure } from './map/measure'
import { createMap, map, setMapsToBeSteered } from './map/tools'
import { addSubstituteBaseMaps } from './map/substituteWms'
import { closeMessageBox, notifyDrawingOutside } from './notifications'
import { getOrtoPhotoProjects } from './ortoPhotoProjects'
import { getLayerGroup } from './request'
import { listenToShortcuts } from './shortcuts'
import { locallyAr5, setCursorType } from './storage'
import { requestGeonorgeToken } from './tokens'

console.log(__APP_VERSION__, import.meta.env);
getLayerGroup(); // to detect whether it is reindrift or ar5web
createMap();
initMeasure();
addSubstituteBaseMaps();
initD3();
setMapsToBeSteered([map]);
requestGeonorgeToken().then(gToken => updateWMTSes(gToken));
listenToShortcuts();

// Setup Openlayers map object
setTimeout(() => {
  map.set('groupPosition', 2); // keep track of group layer index, in case of OSM

  map.once('postrender', () => {
    const m = document.getElementById('map');
    const olControls = document.getElementsByClassName('ol-control');
    for (let i = 0; i < olControls.length; i++) m.appendChild(olControls[i]);
  });

  map.once('loadstart', () => resizeMap()); // Otherwise it moves on feature click

  // Clear points on zoom only:
  // map.getView().on('change:resolution', () => { // this does it on moveend, too late
  map.on('movestart', () => {
    const v = map.getView();
    const zooming = v.getAnimating() && !v.getInteracting();
    if (zooming) {
      // g.selectAll("path").remove(); // keep lines
      g.selectAll('text').remove(); // remove points
    }
    if (locallyAr5 && (v.getAnimating() || v.getInteracting())) {
      closeMessageBox();
      // closeToolbarWindow();
    }
  });

  map.on('moveend', () => {
    updateProjAndExtent();
    // editableRegion = false; // always wait for backend to state if it is true
    enableEditButtons(); // disables when zooming out and backend is not queried
    if (locallyAr5) {
      if (ortoWMS.checked) getOrtoPhotoProjects();
      updateLegend();
    }
  });

  const bar = document.getElementById('bar');
  map.on('pointermove', evt => {
    if (evt.dragging) return;
    const pixel = evt.pixel;
    const hit = map.hasFeatureAtPixel(pixel);
    if (bar.style.display === 'block') setCursorType(hit ? 'pointer' : '');
    else map.getTargetElement().style.cursor = hit ? 'pointer' : '';
    // Notify drawing outside expected area:
    notifyDrawingOutside(pixel);
  });
}, 10);

$('.dropdown-button').dropdown({
  inDuration: 300,
  outDuration: 225,
  constrainWidth: false, // Does not change width of dropdown to that of the activator
  hover: true, // Activate on hover
  gutter: 0, // Spacing from edge
  belowOrigin: false, // Displays dropdown below the button
  alignment: 'left', // Displays dropdown with edge aligned to the left of button
  stopPropagation: false // Stops event propagation
});
